import React, { CSSProperties, createElement } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Serializer, Question, ElementFactory, IElement, SvgRegistry } from 'survey-core';
import { SurveyQuestionElementBase, ReactQuestionFactory } from 'survey-react-ui';
import { SurveyCreator } from 'survey-creator-react';
import { localization } from 'survey-creator-core';
import { IoPersonCircleSharp } from 'react-icons/io5';
import RandoxInuviSurveyComponent, { InuviPatientDetailsData } from './Randox/RandoxInuviSurveyComponent';

export const CUSTOM_INUVI_ORDER_QUESTION_TYPE = 'randox-inuvi-patient-details-fields';

SvgRegistry.registerIconFromSvg(
  CUSTOM_INUVI_ORDER_QUESTION_TYPE,
  ReactDOMServer.renderToString(<IoPersonCircleSharp size="large" />)
);
const locale = localization.getLocale('');
locale.qt[CUSTOM_INUVI_ORDER_QUESTION_TYPE] = 'Confirm Inuvi Order Details';

export class SurveyInuviFields extends Question {
  getType() {
    return CUSTOM_INUVI_ORDER_QUESTION_TYPE;
  }
}

Serializer.addClass(
  CUSTOM_INUVI_ORDER_QUESTION_TYPE,
  [],
  function () {
    return new SurveyInuviFields('');
  },
  'question'
);

export class RandoxInuviOrderFields extends SurveyQuestionElementBase {
  constructor(props: any, bearerToken: string) {
    super(props);
    this.state = { value: this.question.value, model: props.creator.props?.model, bearerToken };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  get style() {
    return this.question.getPropertyValue('readOnly') || this.question.isDesignMode
      ? ({ pointerEvents: 'none' } as CSSProperties)
      : undefined;
  }

  renderElement() {
    const onLoadPatientData = (data: InuviPatientDetailsData) => {
      this.question.value = data;
    };

    return (
      <div style={this.style}>
        <RandoxInuviSurveyComponent onLoadPatientData={onLoadPatientData} />
      </div>
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion(CUSTOM_INUVI_ORDER_QUESTION_TYPE, (props) => {
  // @ts-ignore - React createElement type compatibility issue
  return createElement(RandoxInuviOrderFields, props);
});

const CustomizeSurveyInuviFields = (surveyCreator?: SurveyCreator) => {
  ElementFactory.Instance.registerElement(CUSTOM_INUVI_ORDER_QUESTION_TYPE, (name: string) => {
    return new SurveyInuviFields(name) as IElement;
  });

  if (surveyCreator && !surveyCreator.toolbox.getItemByName(CUSTOM_INUVI_ORDER_QUESTION_TYPE)) {
    surveyCreator.toolbox.addItem({
      name: CUSTOM_INUVI_ORDER_QUESTION_TYPE,
      title: CUSTOM_INUVI_ORDER_QUESTION_TYPE,
      iconName: '',
      json: { type: CUSTOM_INUVI_ORDER_QUESTION_TYPE },
      category: 'Custom Type',
      className: 'svd_custom_type',
      isCopied: false
    });
  }
};

export default CustomizeSurveyInuviFields;
